import axios from "axios";
import BASE_URL from "../_helpers/constants";
import { readCurrentUser } from "../_helpers/currentUser";

// Pooled inbox SP2 — the advisor's reads and writes (contract: Astra-Backend
// docs/superpowers/plans/2026-09-22-pooled-inbox-sp2-plan.md). Each returns the
// axios response like the rest of the service layer; callers read `res.data`.
// The message calls (page, send, mark read) are SP1's, in thread.services.js.
const authHeaders = () => ({
  Authorization: `Bearer ${readCurrentUser()?.token ?? ""}`,
});

export const getInbox = ({ filter, limit, offset } = {}) =>
  axios.get(`${BASE_URL}/threads`, {
    headers: authHeaders(),
    params: { filter, limit, offset },
  });

export const getThread = (threadId) =>
  axios.get(`${BASE_URL}/threads/${threadId}`, { headers: authHeaders() });

export const takeOverThread = (threadId) =>
  axios.post(
    `${BASE_URL}/threads/${threadId}/take-over`,
    {},
    { headers: authHeaders() },
  );

export const openThreadForClient = (clientId) =>
  axios.post(
    `${BASE_URL}/clients/${clientId}/thread`,
    {},
    { headers: authHeaders() },
  );

export const getClientSummary = (clientId) =>
  axios.get(`${BASE_URL}/clients/${clientId}/summary`, {
    headers: authHeaders(),
  });

export const getClientData = (clientId) =>
  axios.get(`${BASE_URL}/clients/${clientId}/data`, { headers: authHeaders() });

export const getClientDocuments = (clientId) =>
  axios.get(`${BASE_URL}/clients/${clientId}/documents-tab`, {
    headers: authHeaders(),
  });

export const saveClientNote = (clientId, text) =>
  axios.put(
    `${BASE_URL}/clients/${clientId}/note`,
    { text },
    { headers: authHeaders() },
  );
